import { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import {
  formatCurrencyMetricParts,
  formatMoney,
  resolveCurrencySymbol,
} from 'helpers/formatMetricDisplay'

const EMPTY_SETTINGS = Object.freeze({}) as Record<string, unknown>

export function useCurrency() {
  const settings = useSelector(
    (state: any) => state.settings?.data || EMPTY_SETTINGS,
    shallowEqual,
  )
  const storeSettings = settings?.store ?? settings

  const currencyCode = useMemo(
    () => String(storeSettings?.currency ?? 'EGP').trim().toUpperCase(),
    [storeSettings?.currency],
  )

  const currencySymbol = useMemo(
    () =>
      resolveCurrencySymbol(
        storeSettings?.currency_symbol as string | undefined,
        currencyCode,
      ),
    [storeSettings?.currency_symbol, currencyCode],
  )

  const formatAmount = useMemo(
    () => (amount: number | string | undefined | null) => formatMoney(amount, currencySymbol),
    [currencySymbol],
  )

  const formatAmountParts = useMemo(
    () => (amount: number | string | undefined | null) =>
      formatCurrencyMetricParts(amount, currencySymbol),
    [currencySymbol],
  )

  return { currencySymbol, currencyCode, formatAmount, formatAmountParts, formatMoney }
}
